"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeContainerIn = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const react_1 = require("react");
const spinner_1 = require("@pulse-web-ui/spinner");
const theme_1 = require("@pulse-web-ui/theme");
const app_parameters_1 = require("@pulse-web-platform-core/app-parameters");
const hooks_1 = require("./hooks");
const use_theme_request_1 = require("./hooks/use-theme-request");
const theme_container_styles_1 = require("./theme-container.styles");
const utils_1 = require("./utils");
const ThemeContainerIn = (_a) => {
    var _b;
    var { children } = _a, props = __rest(_a, ["children"]);
    const { personalization, productName, preset, onPresetLoaded, setAppLoading: setLoading, appLoading: loading, setAppConfig, } = props;
    const [partnername, customname] = ((_b = (personalization || '')) === null || _b === void 0 ? void 0 : _b.split('_')) || [];
    const [presetPartner, presetName] = (preset === null || preset === void 0 ? void 0 : preset.split('_')) || [];
    const themeLink = (0, utils_1.getThemeLink)(partnername, customname);
    const fontLink = partnername
        ? `${app_parameters_1.envUrls.STORAGE_URL}/themes-v2/${String(partnername)}/fonts`
        : '';
    const { isLoading: isLoadingConfig, res: resConfig } = (0, use_theme_request_1.useThemeRequest)('themingRequest', themeLink, [themeLink], !!themeLink);
    const { isLoading: isLoadingPreset, res: resPreset } = (0, hooks_1.usePresetRequest)(productName, presetPartner, presetName);
    const { isLoading: isLoadingTheme, res: resTheme } = (0, use_theme_request_1.useThemeRequest)('theme', (0, utils_1.getThemeURL)(resConfig, partnername, 'ui', 'theme-url'), [resConfig, partnername], !!(0, utils_1.getThemeURL)(resConfig, partnername, 'ui', 'theme-url'));
    const { isLoading: isLoadingIcons, res: resIcons } = (0, use_theme_request_1.useThemeRequest)('icons', (0, utils_1.getThemeURL)(resConfig, partnername, 'icons', 'icons-url'), [resConfig, partnername], !!(0, utils_1.getThemeURL)(resConfig, partnername, 'icons', 'icons-url'));
    const { isLoading: isLoadingTexts, res: resTexts } = (0, use_theme_request_1.useThemeRequest)('texts', (0, utils_1.getThemeURL)(resConfig, partnername, 'i18n', 'texts-url'), [resConfig, partnername], !!(0, utils_1.getThemeURL)(resConfig, partnername, 'i18n', 'texts-url'));
    const { isLoading: isLoadingFlow, res: resFlow } = (0, use_theme_request_1.useThemeRequest)('flow', (0, utils_1.getThemeURL)(resConfig, partnername, 'flows', 'flow-url'), [resConfig, partnername], !!(0, utils_1.getThemeURL)(resConfig, partnername, 'flows', 'flow-url'));
    (0, react_1.useEffect)(() => {
        if (!isLoadingPreset && !!resPreset) {
            onPresetLoaded === null || onPresetLoaded === void 0 ? void 0 : onPresetLoaded(resPreset);
        }
    }, [isLoadingPreset, resPreset, onPresetLoaded]);
    (0, react_1.useEffect)(() => {
        if (!isLoadingFlow && resFlow)
            setAppConfig(resFlow);
    }, [isLoadingFlow, resFlow]);
    const customTheme = (0, react_1.useMemo)(() => {
        if (!loading && resTheme) {
            return (0, lodash_merge_1.default)(theme_1.rgsOnlineTheme, resTheme, resIcons || {});
        }
        return theme_1.rgsOnlineTheme;
    }, [loading, resTheme, resIcons]);
    (0, hooks_1.useFontLink)(fontLink, customTheme);
    (0, react_1.useEffect)(() => {
        setLoading(!!personalization);
    }, [personalization]);
    const loadingCondition = isLoadingConfig ||
        isLoadingTheme ||
        isLoadingIcons ||
        isLoadingTexts ||
        isLoadingFlow ||
        isLoadingPreset;
    (0, react_1.useEffect)(() => {
        setLoading(loadingCondition);
    }, [loadingCondition]);
    (0, hooks_1.useDictionary)(resTexts, isLoadingTexts);
    (0, react_1.useEffect)(() => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    const portals = document.querySelectorAll('reach-portal');
                    portals.forEach((portal) => {
                        if (portal instanceof HTMLElement) {
                            portal.classList.add('theme-container');
                        }
                    });
                    mutation.removedNodes.forEach((node) => {
                        if (node instanceof HTMLElement &&
                            node.classList.contains('theme-container')) {
                            node.classList.remove('theme-container');
                        }
                    });
                }
            });
        });
        const targetNode = document.body;
        const config = { childList: true, subtree: true };
        observer.observe(targetNode, config);
        return () => observer.disconnect();
    }, []);
    if (loading) {
        return ((0, jsx_runtime_1.jsx)(theme_1.StyledThemeProvider, { theme: theme_1.rgsOnlineTheme, children: (0, jsx_runtime_1.jsx)(spinner_1.Spinner, {}) }));
    }
    return ((0, jsx_runtime_1.jsxs)(theme_1.StyledThemeProvider, { theme: customTheme, children: [(0, jsx_runtime_1.jsx)(theme_container_styles_1.GlobalStyle, {}), (0, jsx_runtime_1.jsx)("div", { className: "theme-container", children: (0, jsx_runtime_1.jsx)(theme_container_styles_1.FontContainer, { children: children }) })] }));
};
exports.ThemeContainerIn = ThemeContainerIn;
